export function formatCurrency(amount: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function formatCurrencyCents(amount: number) {
  return formatCurrency(amount / 100);
}

/**
 * Omits the trailing .00 from the formatted currency string if the amount is a whole number.
 * @param cents Price in cents
 */
export function formatCurrencyShort(cents: number) {
  const formatted = formatCurrencyCents(cents);
  return formatted.replace(/\.00$/, ''); // Remove trailing .00
}
